let PackagesItem = [
    {
        id: 1,
        trackTitle: "Day 2: Professionals 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1643703725493x900700300089491500',
    },
    {
        id: 2,
        trackTitle: "Day 1: Beginners",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Day 1: Beginners',
        trackLink: 'https://geekle.us/ticketfree/1643713279230x132764664075649020',
    },
  ];
  
  export default PackagesItem;
  